//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import GAEcommerce from '~/mixins/ga-ecommerce'

export default {
  mixins: [GAEcommerce],
  props: {
    page: {
      type: String,
      default: 'allGoals'
    },
    showBaseComplete: {
      type: Boolean,
      default: true
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    showButtonShowMore: {
      type: Boolean,
      default: true
    },
    showMoreInImage: {
      type: Boolean,
      default: true
    },
    hrefAddButton: {
      type: String,
      required: false,
      default: null
    },
    showPrice: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('product', ['planSelected', 'baseCompleteTests', 'improvementProgramPrice']),
    ...mapGetters({
      isBaseCompleteImprovementPlan: 'product/isBaseCompleteImprovementPlan',
      isQuizPlanResults: 'product/isQuizPlanResults',
      getPlanPriceRaw: 'product/getPlanPriceRaw'
    }),
    items () {
      return this.$t(`${this.page}.testPlans.items`)
    },
    specifications () {
      return this.$t('allGoals.testPlans.completePlan.specifications')
    },
    isPayUpfrontActiveAb () {
      return this.isABActivated('pay-upfront-project')
    }
  },
  methods: {
    trackAddToCart () {
      const plan = 'base-complete-results'
      this.trackFBPixelEvent({
        event: 'AddToCart',
        properties: {
          plan
        }
      })
      this.trackTikTokEvent({
        event: 'AddToCart',
        properties: {
          content_type: 'product',
          content_id: plan,
          content_name: plan
        }
      })
      this.trackGAEcommerceAddToCart({ plan })
    },
    openRemoveQuizPlanModal () {
      if (this.isBaseCompleteImprovementPlan) {
        return this.$store.dispatch('product/removeBaseComplete')
      } else if (this.isQuizPlanResults) {
        this.$store.dispatch('product/selectPlanToAdd', 'base-complete-improvement-plan')
        this.$root.$emit('bv::show::modal', 'removeQuizPlanModal')
      } else {
        this.trackAddToCart()
        if (this.isPayUpfrontActiveAb) {
          this.$store.dispatch('product/selectBaseCompleteImprovementPlanPayUpfront')
        } else {
          this.$store.dispatch('product/selectBaseCompleteImprovementPlan')
        }
      }
    }
  }
}
